// extracted by mini-css-extract-plugin
export default {"values":"styles_values__z0Rl0","value":"styles_value__9KfVX","inner":"styles_inner__fm5V4","close":"styles_close__5NaRD","avatar":"styles_avatar__H36Hr","name":"styles_name__U3Jem"};